import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Location, NgIf, NgClass } from '@angular/common';
import { ConversationService } from '../conversation.service';
import { TwilioService } from '../twilio.service';
import { Subject, Subscription, catchError, of, takeUntil } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '../shared/services/loader.service';
import { NgxSpinnerComponent } from 'ngx-spinner';
import { ConversationContentComponent } from './components/conversation-content/conversation-content.component';
import { ConversationListComponent } from './components/conversation-list/conversation-list.component';

@Component({
    selector: 'app-conversation',
    templateUrl: './conversation.component.html',
    styleUrls: ['./conversation.component.css'],
    imports: [NgIf, ConversationListComponent, NgClass, ConversationContentComponent, NgxSpinnerComponent]
})
export class ConversationComponent implements OnInit, OnDestroy {

  conversations: any[] = [];
  unreadMessages: any = [];
  unreadMessagesCount: number = 0
  chatList: any[] = [];
  selectedConversion: any = null;
  isLoading: boolean = false;
  isMobileDevice: boolean = /Mobi/i.test(window.navigator.userAgent);
  componentDestroyed$: Subject<boolean> = new Subject()
  private routeSub: Subscription;
  conversationId: any = null;
  currentUserNumber: string = null;

  @Output() totalUnread: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public location: Location,
    private conversationService: ConversationService,
    private twilioService: TwilioService,
    private loaderService: LoaderService,
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.currentUserNumber = JSON.parse(localStorage.getItem('login')).defaultNumber;
    this.conversations = [];
    this.subscribeConversation();

    this.routeSub = this.route.params.subscribe(params => {
      this.conversationId = params['id'];
      if(this.conversations.length > 0){
        this.getSelectedConversation();
      }
    });
  }

  setSelectedConversation(data: any) {
    if(!data) {
      this.router.navigateByUrl('communications');
      return;
    }
    this.router.navigateByUrl(`communications/${data.id}`);
  }

  getSelectedConversation() {
    if(this.conversations.length > 0){
      if(this.conversationId) {
        this.selectedConversion = this.conversations.find(o => o.id === this.conversationId);
      }
    }
  }

  subscribeConversation() {
    this.loaderService.showSpinner();
    this.conversationService.chatListValue
      .pipe(takeUntil(this.componentDestroyed$), catchError(err => of(err)))
      .subscribe((data) => {
        if (data) {
          this.chatList = data;
          this.conversations = data;
          this.getSelectedConversation();
        } else {
          // TODO: Handle No Conversation
        }
        this.loaderService.hideSpinner();
      });

    this.conversationService.conversationAddedValue
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((conv) => {
        setTimeout(async () => {
          if (conv) {
            if (conv.dateCreated && conv.dateCreated > new Date()) {
              await conv.setAllMessagesUnread();
              let newChat = {
                chat: conv,
                unreadCount: 0,
                lastConversation: '',
                clientId: null
              }
              this.chatList = [newChat, ...this.chatList];
              this.conversations = this.chatList
            }
          }
        }, 500);
      });

    this.conversationService.messageAdded
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((msg) => {
        if (this.chatList) {
          this.chatList.forEach((convo) => {
            if (convo?.chat?.sid === msg?.conversation.sid) {
              const type = msg.media ? msg.media.contentType.slice(0, msg.media.contentType.indexOf('/')): null;
              convo.lastConversation = type ? `Attachment: 1 ${type}`: msg.body;
            }

            // const lastMessageIndex = convo?.chat?.lastMessage?.index;
            // let count = lastMessageIndex - (convo?.chat?.lastReadMessageIndex !== null ? convo?.chat?.lastReadMessageIndex : -1)
          });
        }
    });

    this.conversationService.unreadMessages
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((data: any) => {
        if (data) {
          this.unreadMessages = data;
        }
      });
  }

  fetchUserChats() {
    this.isLoading = true;
    this.twilioService.fetchUserChats();
    this.isLoading = false;
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true)
    this.componentDestroyed$.complete()
  }

  countUnread(count){
    this.totalUnread.emit(count)
  }
}


